import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox } from '@dixa/lib-shared-habla';
import noop from 'lodash/noop';
import { useCallback, useState } from 'react';
import { InstagramFeatureToggle } from './components/instagramFeatureToggle/instagramFeatureToggle';
export const InstagramFeatures = (props) => {
    var _a, _b;
    const [isStoryMentionsEnabled, setIsStoryMentionsEnabled] = useState((_a = props.features) === null || _a === void 0 ? void 0 : _a.isStoryMentionsEnabled);
    const [isStoryCommentsEnabled, setIsStoryCommentsEnabled] = useState((_b = props.features) === null || _b === void 0 ? void 0 : _b.isStoryCommentsEnabled);
    /** Handles toggling the mentions feature on/off. */
    const handleMentionsFeatureChange = useCallback((event) => {
        const { onChange } = props;
        setIsStoryMentionsEnabled(event.target.checked);
        onChange({
            isStoryMentionsEnabled: event.target.checked,
            isStoryCommentsEnabled,
        });
    }, [isStoryCommentsEnabled, props]);
    /** Handles toggling the comments feature on/off. */
    const handleCommentsFeatureChange = useCallback((event) => {
        const { onChange } = props;
        setIsStoryCommentsEnabled(event.target.checked);
        onChange({
            isStoryMentionsEnabled,
            isStoryCommentsEnabled: event.target.checked,
        });
    }, [isStoryMentionsEnabled, props]);
    return (_jsxs(FlexBox, Object.assign({ gap: "300", flexDirection: "column", margin: "300 0 0" }, { children: [_jsx(InstagramFeatureToggle, { input: {
                    name: 'messages-enabled',
                    value: 'messages',
                    checked: true,
                    disabled: true,
                    onChange: noop,
                }, inputLabel: "Receive direct messages", tooltipLabel: "Conversations are created when a user is engaging directly with your Instagram page. Every new user message will appear in the Dixa conversation" }), _jsx(InstagramFeatureToggle, { input: {
                    name: 'mentions-enabled',
                    value: 'mentions',
                    checked: isStoryMentionsEnabled,
                    onChange: handleMentionsFeatureChange,
                }, inputLabel: "Receive story mentions", tooltipLabel: "Conversations are created when a user mentions your Instagram handle inside their story. Every story mention will appear in the Dixa conversation and you will be able to engage via a direct message with the user that posted the story" }), _jsx(InstagramFeatureToggle, { input: {
                    name: 'comments-enabled',
                    value: 'comments',
                    checked: isStoryCommentsEnabled,
                    onChange: handleCommentsFeatureChange,
                }, inputLabel: "Receive story comments", tooltipLabel: "Conversations are created when a user adds a comment to any of the stories you posted. Every story comment will appear in the Dixa conversation and you will be able to engage via a direct message with the user that posted the story" })] })));
};
